/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse {
    

    priorAdresses?: Array<models.LDCLPBPPublicApiModelsLoanApplicationsMortgageMortgageBorrowerAddressResponse>;

    employers?: Array<models.LDCLPBPPublicApiModelsLoanApplicationsMortgageMortgageBorrowerEmploymentInfo>;

    loanGoal?: string;

    monthlyRetirementIncome?: number;

    monthlySocialSecurityIncome?: number;

    monthlyOtherIncome?: number;

    coMonthlyRetirementIncome?: number;

    coMonthlySocialSecurityIncome?: number;

    coMonthlyOtherIncome?: number;

    mortgageBalance?: number;

    secondMortgageBalance?: number;

    pricingValidationResults?: Array<string>;

    offRampReasons?: Array<string>;

    currentHousingExpense?: models.LDCLPBPPublicApiModelsLoanApplicationsHousingExpensesHousingExpense;

    propHousingExpense?: models.LDCLPBPPublicApiModelsLoanApplicationsHousingExpensesHousingExpense;

    firstName?: string;

    middleName?: string;

    lastName?: string;

    suffix?: string;

    email?: string;

    coBorrower?: Array<string>;

    livingSituation?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.LivingSituationEnum;

    personalStreet1?: string;

    personalStreet2?: string;

    personalCity?: string;

    personalState?: string;

    personalZipCode?: string;

    personalUnit?: string;

    telephone?: string;

    dob?: Date;

    annualSalary?: string;

    vaEligible?: boolean;

    maritalStatus?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.MaritalStatusEnum;

    coMaritalStatus?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.CoMaritalStatusEnum;

    mailingStreet1?: string;

    mailingStreet2?: string;

    mailingCity?: string;

    mailingState?: string;

    mailingZipCode?: string;

    coFirstName?: string;

    coMiddleName?: string;

    coLastName?: string;

    coSuffix?: string;

    coEmail?: string;

    coAnnualSalary?: number;

    coLivingSituation?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.CoLivingSituationEnum;

    coMonthlyPayment?: number;

    coPersonalStreet1?: string;

    coPersonalStreet2?: string;

    coPersonalCity?: string;

    coPersonalState?: string;

    coPersonalZipCode?: string;

    coPersonalUnit?: string;

    coTelephone?: string;

    coDOB?: Date;

    coVaEligible?: boolean;

    propertyStreet1?: string;

    propertyStreet2?: string;

    propertyCity?: string;

    propertyState?: string;

    propertyZipcode?: string;

    propertyType?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.PropertyTypeEnum;

    targetCloseDate?: Date;

    estimatedPropertyValue?: number;

    estimatedPropertyTax?: number;

    howUsingProperty?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.HowUsingPropertyEnum;

    borrowerAsset?: Array<models.LDCLPBPPublicApiModelsLoanApplicationsMortgageBankAsset>;

    coBorrowerAsset?: Array<models.LDCLPBPPublicApiModelsLoanApplicationsMortgageBankAsset>;

    govOutstandingJudgements?: boolean;

    govBankrupt?: boolean;

    govForeclose?: boolean;

    govPartyToLawsuit?: boolean;

    govRecentForeclosure?: boolean;

    govDelinquent?: boolean;

    govAlimony?: boolean;

    govUsCitizen?: boolean;

    govOwnershipInterest?: boolean;

    govBorrowedDownPayment?: boolean;

    govCoMakerNote?: boolean;

    govIntendOccupy?: boolean;

    govGender?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.GovGenderEnum;

    govEthnicity?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.GovEthnicityEnum;

    govRace?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.GovRaceEnum;

    selectedLoanProgram?: string;

    selectedPlanNumber?: number;

    id?: string;

    leadNumber?: string;

    isTestLoan?: boolean;

    lastModified?: Date;

    downPayment?: number;

    loanAmount?: number;

    interestRate?: number;

    apr?: number;

    numberOfPayments?: number;

    dateOfFirstPayment?: Date;

    monthlyPayment?: number;

    loanClass?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.LoanClassEnum;

    loanClassOther?: string;

    county?: string;

    propertyAddress?: models.LDCLPBPPublicApiModelsCommonAddress;

    mailingAddress?: models.LDCLPBPPublicApiModelsCommonAddress;

    legalDescription?: string;

    yearBuilt?: number;

    units?: number;

    loanPurpose?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.LoanPurposeEnum;

    loanPurposeOther?: string;

    purchasePrice?: number;

    appraisedValue?: number;

    lotYearAcquired?: number;

    lotOriginalCost?: number;

    lotExistingLiens?: number;

    lotPresentValue?: number;

    lotImprovementCost?: number;

    yearAcquired?: number;

    originalCost?: number;

    existingLiens?: number;

    refiPurpose?: LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse.RefiPurposeEnum;

    improvementsMade?: boolean;

    improvementsProposed?: boolean;

    improvementsDescription?: string;

    improvementsCost?: number;

    primaryBorrowerId?: string;

    borrowers?: Array<models.LDCLPBPPublicApiModelsBorrowersMortgageBorrower>;
}
export namespace LDCLPBPPublicApiModelsLoanApplicationsMortgageGetMortgageLoanApplicationReviewResponse {

    export enum LivingSituationEnum { 
        Unknown = <any> 'Unknown',
        Own = <any> 'Own',
        Rent = <any> 'Rent',
        Other = <any> 'Other',
    }

    export enum MaritalStatusEnum { 
        Unknown = <any> 'Unknown',
        Married = <any> 'Married',
        Unmarried = <any> 'Unmarried',
        Separated = <any> 'Separated',
    }

    export enum CoMaritalStatusEnum { 
        Unknown = <any> 'Unknown',
        Married = <any> 'Married',
        Unmarried = <any> 'Unmarried',
        Separated = <any> 'Separated',
    }

    export enum CoLivingSituationEnum { 
        Unknown = <any> 'Unknown',
        Own = <any> 'Own',
        Rent = <any> 'Rent',
        Other = <any> 'Other',
    }

    export enum PropertyTypeEnum { 
        Unspecified = <any> 'Unspecified',
        SingleFamilyDetached = <any> 'SingleFamilyDetached',
        SingleFamilyAttached = <any> 'SingleFamilyAttached',
        AttachedLowRiseCondoOneToFour = <any> 'AttachedLowRiseCondoOneToFour',
        AttachedMidRiseCondoFiveToEight = <any> 'AttachedMidRiseCondoFiveToEight',
        AttachedHighRiseCondoNinePlus = <any> 'AttachedHighRiseCondoNinePlus',
        MixedUseCondo = <any> 'MixedUseCondo',
        RowHouse = <any> 'RowHouse',
        ManufacturedHome = <any> 'ManufacturedHome',
        DoubleWideMobile = <any> 'DoubleWideMobile',
        MixedUse = <any> 'MixedUse',
        SingleWideMobile = <any> 'SingleWideMobile',
        UnimprovedLandLot = <any> 'UnimprovedLandLot',
        CoOp = <any> 'CoOp',
        PropertyUnderDevelopment = <any> 'PropertyUnderDevelopment',
        Modular = <any> 'Modular',
        TwoUnit = <any> 'TwoUnit',
        ThreeUnit = <any> 'ThreeUnit',
        FourUnit = <any> 'FourUnit',
        DetachedCondo = <any> 'DetachedCondo',
        NonWarrantableCondo = <any> 'NonWarrantableCondo',
    }

    export enum HowUsingPropertyEnum { 
        Unspecified = <any> 'Unspecified',
        OwnerOccupied = <any> 'OwnerOccupied',
        SecondHome = <any> 'SecondHome',
        InvestmentProperty = <any> 'InvestmentProperty',
    }

    export enum GovGenderEnum { 
        Unknown = <any> 'Unknown',
        Female = <any> 'Female',
        Male = <any> 'Male',
        NotProvided = <any> 'NotProvided',
        NotApplicable = <any> 'NotApplicable',
    }

    export enum GovEthnicityEnum { 
        Unknown = <any> 'Unknown',
        Hispanic = <any> 'Hispanic',
        NonHispanic = <any> 'NonHispanic',
        NotProvided = <any> 'NotProvided',
        NotApplicable = <any> 'NotApplicable',
    }

    export enum GovRaceEnum { 
        AmericanIndian = <any> 'AmericanIndian',
        Asian = <any> 'Asian',
        Black = <any> 'Black',
        NativeHawaian = <any> 'NativeHawaian',
        White = <any> 'White',
        NoInformation = <any> 'NoInformation',
        NotApplicable = <any> 'NotApplicable',
        NotProvided = <any> 'NotProvided',
    }

    export enum LoanClassEnum { 
        Unknown = <any> 'Unknown',
        Conventional = <any> 'Conventional',
        FHA = <any> 'FHA',
        VA = <any> 'VA',
        USDA = <any> 'USDA',
        Others = <any> 'Others',
    }

    export enum LoanPurposeEnum { 
        Purchase = <any> 'Purchase',
        RateTermRefinance = <any> 'RateTermRefinance',
        CashOutRefinance = <any> 'CashOutRefinance',
        StreamlineRefi = <any> 'StreamlineRefi',
        Unspecified = <any> 'Unspecified',
        HELOC = <any> 'HELOC',
        HELOCPurchase = <any> 'HELOCPurchase',
    }

    export enum RefiPurposeEnum { 
        Unknown = <any> 'Unknown',
        CashOutDebtConsolidation = <any> 'CashOutDebtConsolidation',
        CashOutHomeImprovement = <any> 'CashOutHomeImprovement',
        CashOutLimited = <any> 'CashOutLimited',
        CashOutOther = <any> 'CashOutOther',
        NoCashOutFHAStreamlined = <any> 'NoCashOutFHAStreamlined',
        NoCashOutFREOwned = <any> 'NoCashOutFREOwned',
        NoCashOutOther = <any> 'NoCashOutOther',
        NoCashOutStreamlined = <any> 'NoCashOutStreamlined',
        ChangeInRateTerm = <any> 'ChangeInRateTerm',
        PortfolioRetentionStreamlined = <any> 'PortfolioRetentionStreamlined',
    }
}
